module.exports = __webpack_public_path__ + "img/product_banner_m.a0d3ce65.jpg";